import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type { MusicTracks } from "../../managers/music/types/music";

export type Musics = {
    getAllMusics: () => MusicTracks;
};

export function useMusics(): Musics {
    const { musicManager } = useSdk();

    return useMemo<Musics>(
        () => ({
            getAllMusics: () => musicManager.getAllMusics(),
        }),
        [musicManager],
    );
}
